import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './core/auth/auth.service';
import { TelegramService } from './core/telegram/telegram.service';
import { User } from './core/models/auth.model';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatIconModule],
  template: `<router-outlet></router-outlet>`,
  styles: [],
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private telegramService: TelegramService,
  ) {}

  ngOnInit(): void {
    this.bootstrapAuth().subscribe({
      error: () => {
        // Токены уже очищены в AuthService.initializeAuth / authInterceptor;
        // здесь только не допускаем unhandled rejection.
      },
    });
  }

  private bootstrapAuth(): Observable<User | null> {
    if (this.telegramService.isTelegram && this.telegramService.initData && !this.authService.accessToken) {
      return this.authService.loginTelegram(this.telegramService.initData).pipe(
        map(res => res.user),
        catchError(() => this.authService.initializeAuth()),
      );
    }
    return this.authService.initializeAuth();
  }
}